module.exports = __webpack_public_path__ + "static/all-in-one-6efcd8d841778159c6a7d665b83c8d74.png";